<div
  class="widget-core-wrapper"
  [ngClass]="{'disabled': !widget.hasPermission}"
>

  @if (!widget.hasPermission) {
    <div class="background-disabled"></div>
  }

  <div class="header">

    <div class="title-wrapper">

      <div class="title">{{ widget.name | translate }}</div>

      <div class="icon-wrap">

        @if (!isStoreView) {

          <yu-icon name="caret-right" color="medium"></yu-icon>

        } @else {

          <div class="button-icon icon-background" [ngClass]="widget.favorite ? 'error' : 'success'">
            <yu-icon [name]="widget.favorite ? 'minus' : 'plus'" color="light"></yu-icon>
          </div>

        }

      </div>

    </div>

    @if (subheader) {
      <div class="subheader">{{ subheader | translate }}</div>
    }

  </div>

  <ng-content></ng-content>

</div>
